import type { Device } from '@studio/models/device';
import type { PTZ } from '@studio/models/ptz';
import type { T_Maybe } from '@tryiris-ai/js-types';
import type { DeviceMovementTool } from './types.js';

/** Keeps track a device's last movement intent. */
export const lastIntent = new Map<
  Device['id'],
  T_Maybe<
    PTZ & {
      timestamp: number;
    }
  >
>();

/** Tracks whether a device is currently in an active continuous move session. */
export const activeMovementDevices = new Set<Device['id']>();

/** Tracks the tool used for the current move session. */
export const activeMovementTools = new Map<Device['id'], DeviceMovementTool>();

export const timeout = 250;
